import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import queryString from 'query-string'
import i18n from 'i18next'
import AppLoading from '../AppLoading'
import Button from '../../UniformComponents/Button'
import '../DynamicDashV3/dynamicDashboard.scss'
import '../../../node_modules/react-grid-layout/css/styles.css'
import Select from '../form/Select'
import EventPicker from './EventPicker'
import SalesIntelligenceStore from './SalesIntelligenceStore'

import './style.scss'
import CompanyView from './CompanyView'
import ExhibitorView from './ExhibitorView'

@observer
class SalesIntelligence extends Component {
    constructor(props) {
        super(props)
        this.state = {
            initializing: true,
        }
        this.init()
    }

    componentDidMount() {
        const { store, surveyDash } = this.props
        if (!surveyDash) {
            store.breadcrumps = [
                {
                    name: 'salesIntelligence',
                    url: '/salesIntelligence',
                    title: 'Sales Intelligence',
                },
            ]
        }
        window.addEventListener('beforeunload', this.handleBeforeUnload)
    }

    init = async () => {
        const { store } = this.props
        this.salesIntelligenceStore = new SalesIntelligenceStore(store)
        await this.salesIntelligenceStore.init()
        await this.salesIntelligenceStore.initCompanyPage()
        this.setState({ initializing: false })
    }

    renderSIPage = () => {
        const { page, loading } = this.salesIntelligenceStore
        if (loading) return null
        if (page === 'companyView') {
            return <CompanyView salesIntelligenceStore={this.salesIntelligenceStore} />
        }
        if (page === 'exhibitorView') {
            return <ExhibitorView salesIntelligenceStore={this.salesIntelligenceStore} />
        }

        return null
    }

    render() {
        const { surveyDash, history, store } = this.props
        const { survey } = store
        const { showBranchBanner } = survey
        const { initializing } = this.state
        const { product } = this.salesIntelligenceStore
        if (initializing) return <AppLoading noBg />

        const { location } = window
        const params = queryString.parse(location.search)

        if (!params.productId) {
            return (
                <EventPicker
                    dashStore={this.salesIntelligenceStore}
                    history={history}
                />
            )
        }

        return (
            <Fragment>
                <div className="salesIntelligenceHeader">
                    <div className="leftHalf">
                        <div className="eventIcon">
                            <i className="fa-light fa-calendar-days" />
                        </div>
                        <div className="eventName">
                            <div className="eventTag">{i18n.t('event')}</div>
                            <div className="eventName">{this.salesIntelligenceStore.product.name}</div>
                        </div>
                        <Button
                            label="Change event"
                            cssClass="regular tertiary"
                            onClick={() => { window.location.href = '/salesIntelligence' }}
                        />
                    </div>
                    {this.salesIntelligenceStore.page !== 'companyView' ? (
                        <div className="siHeaderFilter">
                            <Button
                                label="Event summary"
                                cssClass="regular tertiary"
                                onClick={() => { window.location.href = `/salesIntelligence?productId=${product.productId}` }}
                            />
                            <div className="filterLabel">
                                <span style={{ fontWeight: 600 }}>{i18n.t('salesIntelligence.filterBy')}</span>
                            </div>
                            <div
                                className="pinnedFilter"
                                style={{
                                    width: '250px', height: '30px',
                                }}
                            >
                                <Select
                                    options={
                                        this.salesIntelligenceStore
                                            .companyPageData
                                            .exhibitorList
                                            .map(({ name, surveyDataIds }) => (
                                                { label: name, value: name, surveyDataIds }
                                            ))
                                    }
                                    onBlur={(option) => {
                                        this.salesIntelligenceStore.changeExhibitor(option)
                                        this.salesIntelligenceStore.trackSIExhibitorFilterChange()
                                    }}
                                    defaultValue={this.salesIntelligenceStore.company}
                                />
                            </div>
                        </div>
                    ) : null}
                </div>
                <div
                    id="dynamicDashboard"
                    className={`
                    salesIntelligence ${showBranchBanner ? 'branching' : ''} 
                    ${surveyDash ? 'survey-view-wrapper' : ''}
                    `}
                >
                    <div
                        style={{
                            display: 'flex', alignItems: 'center', flexDirection: 'column',
                        }}
                        className="grid-parent"
                    >
                        {this.renderSIPage()}
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default SalesIntelligence
